export enum DeviceType {
  EndpointMP2 = 'EndpointMP2',
  EndpointBF = 'EndpointBF',
  EndpointLF = 'EndpointLF',
  EndpointHF = 'EndpointHF',
  HeadUnit = 'HeadUnit',
  Gateway = 'Gateway',
  GatewayHME = 'GatewayHME',
  Unknown = 'Unknown'
}

export const isDeviceType = (type: string): boolean => {
  return Object.values(DeviceType).includes(type as DeviceType);
};
